import http from "../httpService";
import {getBaseUrl} from "../../config";

export const submitUserReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/user_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/user_report?${paginate}`,
    data
  );
};

export const submitUserRoleReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/user_role_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/user_role_report?${paginate}`,
    data
  );
};

export const submitUserNotificationReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/user_notification_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/user_notification_report?${paginate}`,
    data
  );
};
